import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import LoadingSpinner from "../../Loading/component";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import moment from "moment-timezone";
import awaitingIcon from "../../../assests/awaitingIcon.svg";
import search from "../../../assests/search.svg";
import combodetailsIcon from "../../../assests/combodetailsIcon.svg";
import emotions7 from "../../../assests/emotions7.svg";
import remove from "../../../assests/remove.svg";

export const ComboDetailsComponent = (props) => {
  const { comboId } = useParams();
  const [machineSearchQuery, setMachineSearchQuery] = useState("");
  const [showVMModal, setShowVMModal] = useState(false);
  const [selectedVMIDs, setSelectedVMIDs] = useState([]);
  const isMobile = window.innerWidth <= 576;

  const handleSeeMore = (vmIDs) => {
    setSelectedVMIDs(vmIDs);
    setShowVMModal(true);
  };

  const handleCloseModal = () => {
    setShowVMModal(false);
    setSelectedVMIDs([]);
  };
  
  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  const handleSearchChange = (e) => {
    setMachineSearchQuery(e.target.value);
  };

  const filteredCohorts = props.comboDetailsData?.combo_cohorts?.filter(
    (machine) => {
      const cohortIdString = String(machine?.cohort_id || "");
      const searchQueryString = String(machineSearchQuery || "");

      return searchQueryString
        ? cohortIdString.includes(searchQueryString)
        : true;
    }
  );

  const handleAddCohortCombo = () => {
    navigate(`/home/comboupdatecohort/${comboId}`);
  };
  
  const handleUpdateComboDetails = () => {
    navigate(`/home/comboupdatedetails/${comboId}`);
  };

  return (
    <div className="cd-main-wrapper">
      <div className="cd-sidebar-container">
        <Sidebar />
      </div>
      
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="cd-content-wrapper">
          {/* Header */}
          <div className="cd-header">
            <button onClick={arrowClick} className="cd-back-btn">
              <img src={leftArrow} alt="Back" />
            </button>
            <h1 className="cd-title">Combo ID <span>{props.comboDetailsData?.id}</span></h1>
          </div>

          {/* Combo Details Section */}
          <div className="cd-section">
            <div className="cd-section-header">
              <div className="cd-section-title">
                <img src={combodetailsIcon} alt="Combo" />
                <h2>Combo Details</h2>
              </div>
              <div className="cd-section-actions">
                <button 
                  className="cd-btn cd-btn-edit"
                  onClick={() => handleUpdateComboDetails(comboId)}
                >
                  Edit
                </button>
              </div>
            </div>

            <div className="cd-info-grid">
              {/* Left - Image */}
              <div className="cd-info-left">
                <div className="cd-image-wrapper">
                  <img
                    src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${props.comboDetailsData?.image_url}`}
                    alt="Combo"
                    className="cd-image"
                  />
                </div>
                <p className="cd-apply-info">
                  <strong>Apply on:</strong>{" "}
                  {props.comboDetailsData?.kiosk_app_enabled && 
                   props.comboDetailsData?.consumer_app_enabled
                    ? "Kiosk and Consumer App"
                    : props.comboDetailsData?.kiosk_app_enabled
                    ? "Kiosk"
                    : props.comboDetailsData?.consumer_app_enabled
                    ? "Consumer App"
                    : "Not available"}
                </p>
              </div>

              {/* Right - Details */}
              <div className="cd-info-right">
                <h2 className="cd-name">{props.comboDetailsData?.name}</h2>
                <p className="cd-description">
                  <strong>Description:</strong> {props.comboDetailsData?.description}
                </p>

                <div className="cd-price-date-grid">
                  <div className="cd-price-card">
                    <p><strong>Actual Price:</strong> ₹{props.comboDetailsData?.actual_price}</p>
                    <p><strong>Selling Price:</strong> ₹{props.comboDetailsData?.total_price}</p>
                  </div>
                  <div className="cd-date-card">
                    <p>
                      <strong>Active Date:</strong>{" "}
                      {moment.utc(props.comboDetailsData?.activates_at)
                        .tz("Asia/Kolkata")
                        .format("YYYY-MM-DD")}
                    </p>
                    <p className="cd-expire-date">
                      <strong>Expire Date:</strong>{" "}
                      {moment.utc(props.comboDetailsData?.expires_at)
                        .tz("Asia/Kolkata")
                        .format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>

                {/* ✅ MVID Table - Scrollable */}
                <div className="cd-mvid-section">
                  <p className="cd-mvid-title">📦 Product Items</p>
                  <div className="cd-table-wrapper">
                    <table className="cd-table">
                      <thead>
                        <tr>
                          <th>MVID</th>
                          <th>Quantity</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.comboDetailsData?.mv_config?.length > 0 ? (
                          props.comboDetailsData?.mv_config?.map((item) => (
                            <tr key={item.mv_id}>
                              <td>{item.mv_id}</td>
                              <td>{item.quantity}</td>
                              <td>₹{item.price}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="cd-no-results">No items available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Combo Mapping Section */}
          <div className="cd-section">
            <div className="cd-section-header">
              <div className="cd-section-title">
                <img src={combodetailsIcon} alt="Combo" />
                <h2>Combo Mapping</h2>
              </div>
              <div className="cd-section-actions">
                {props.comboDetailsData?.combo_cohorts?.length > 0 ? (
                  <>
                    <button 
                      className="cd-btn cd-btn-remove"
                      onClick={props.handleRemoveClick}
                    >
                      Remove
                    </button>
                    <button 
                      className="cd-btn cd-btn-add"
                      onClick={() => handleAddCohortCombo(comboId)}
                    >
                      Add
                    </button>
                  </>
                ) : (
                  <button 
                    className="cd-btn cd-btn-add"
                    onClick={() => handleAddCohortCombo(comboId)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>

            {props.comboDetailsData?.combo_cohorts?.length > 0 ? (
              <div className="cd-mapping-content">
                <div className="cd-search-wrapper">
                  <img src={search} alt="Search" className="cd-search-icon" />
                  <input
                    type="search"
                    value={machineSearchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search by cohort ID"
                    className="cd-search-input"
                  />
                </div>

                {/* ✅ Cohort Table - Scrollable */}
                <div className="cd-cohort-table-wrapper">
                  <table className="cd-cohort-table">
                    <thead>
                      <tr>
                        <th style={{ width: "50px" }}></th>
                        <th>Cohort ID</th>
                        <th>V.M ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCohorts?.length > 0 ? (
                        filteredCohorts.map((item) => (
                          <tr key={item.cohort_id}>
                            <td>
                              {props.showTableForRemoval && (
                                <button 
                                  className="cd-remove-icon-btn"
                                  onClick={() => props.handleConfirmRemove(item.cohort_id)}
                                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                                >
                                  <img src={remove} alt="Remove" className="cd-remove-icon" />
                                </button>
                              )}
                            </td>
                            <td>{item.cohort_id}</td>
                            <td>
                              {item.vm_ids.slice(0, 20).join(", ")}
                              {item.vm_ids.length > 20 && (
                                <button 
                                  className="cd-see-more-btn"
                                  onClick={() => handleSeeMore(item.vm_ids)}
                                >
                                  ... See More
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="cd-no-results">
                            No cohorts found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {props.showTableForRemoval && (
                  <button 
                    className="cd-btn cd-btn-cancel"
                    onClick={props.handleCancelRemove}
                    style={{ marginTop: '12px' }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            ) : (
              <div className="cd-empty-state">
                <div className="cd-empty-image">
                  <img src={emotions7} alt="No combos found" />
                </div>
                <p className="cd-empty-text">No combos found</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      <Modal
        show={props.showConfirmModal}
        onHide={() => props.setShowConfirmModal(false)}
        centered
        className="cd-modal"
      >
        <Modal.Body className="cd-modal-body">
          <img src={awaitingIcon} alt="Confirmation" className="cd-modal-icon" />
          <p className="cd-modal-text">Are you sure you want to remove it?</p>
          <div className="cd-modal-actions">
            <button 
              className="cd-modal-btn-cancel"
              onClick={() => props.setShowConfirmModal(false)}
            >
              Cancel
            </button>
            <button 
              className="cd-modal-btn-confirm"
              onClick={props.confirmRemove}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* VM IDs Modal */}
      <Modal
        show={showVMModal}
        onHide={handleCloseModal}
        centered
        className="cd-vm-modal"
      >
        <Modal.Body className="cd-vm-modal-body">
          <h4 className="cd-vm-modal-title">🖥️ VM IDs ({selectedVMIDs.length})</h4>
          <div className="cd-vm-list">
            {selectedVMIDs.map((id, index) => (
              <span key={index} className="cd-vm-tag">{id}</span>
            ))}
          </div>
          <button 
            className="cd-vm-modal-close"
            onClick={handleCloseModal}
          >
            Close
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};